export default {
    init() {
        // JavaScript to be fired on the source of growth template

        // ON SVM FORM SUBMIT
        (function(){
            
            // Get the form element by its ID
            const form = document.getElementById('jsViableMarketForm');

            // Function to format input fields with a dollar sign
            function formatCurrencyInput(input) {
                let value = input.value.replace(/[^\d.]/g, ''); // Remove non-numeric and non-dot characters
                if (value !== '') {
                    // value = parseFloat(value).toFixed(2); // Convert to float and format to 2 decimal places
                    value = '$' + value.replace(/\B(?=(\d{3})+(?!\d))/g, ','); // Add commas for thousands and dollar sign
                }
                input.value = value;
            }

            // Function to allow only numeric input
            function allowOnlyNumbers(input) {
                input.addEventListener('input', function() {
                    input.value = input.value.replace(/[^0-9]/g, ''); // Remove non-numeric characters
                });
            }

            // Add event listeners to format currency inputs
            const revenueGoalInput = document.getElementById('revenueGoal');
            revenueGoalInput.addEventListener('input', function() {
                formatCurrencyInput(revenueGoalInput);
            });

            const saleValueByProductInput = document.getElementById('saleValueByProduct');
            saleValueByProductInput.addEventListener('input', function() {
                formatCurrencyInput(saleValueByProductInput);
            });

            const purchasesByProductInput = document.getElementById('purchasesByProduct');
            purchasesByProductInput.addEventListener('input', function() {
                allowOnlyNumbers(purchasesByProductInput);
            });

            // Add a submit event listener to the form
            form.addEventListener('submit', function(event) {
                event.preventDefault();

                // Remove dollar signs and commas for computation
                const revenueGoal = parseFloat(revenueGoalInput.value.replace(/\$/g, '').replace(/,/g, ''));
                const saleValueByProduct = parseFloat(saleValueByProductInput.value.replace(/\$/g, '').replace(/,/g, ''));
                const purchasesByProduct = parseFloat(purchasesByProductInput.value);

                // Calculate the smallest viable market
                const smallestViableMarket = revenueGoal / (saleValueByProduct * purchasesByProduct);

                // Get the result element by its ID
                const resultElement = document.getElementById('VMR');

                // Update the result element with the calculated value
                resultElement.textContent = Math.round(smallestViableMarket);

                // Show the result div using Bootstrap's collapse function
                const resultDiv = document.getElementById('jsVMResult');
                resultDiv.classList.remove('collapse');
            });

        })();
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/svm.js